import { useFlags } from "launchdarkly-react-client-sdk";

import {
  useHasProductTabs,
  useProjectsAccess,
} from "src/components/layout/nav/sections/hooks/projects";
import { useClassicNavPreference } from "src/components/layout/nav/use-classic-nav";
import { getSavedIsProductNav } from "src/contexts/nav-width-context";

/**
 * Whether this viewer has the product nav, whose collapsed state leaves the window; the classic nav keeps its rail.
 * While access loads it holds what the last load had, so a reload never paints the rail before the trigger,
 * and a viewer without the flag never sees the product nav's frame flash in first.
 */
export const useIsMiniNavEligible = () => {
  const { appAmpV2 } = useFlags();
  const hasProductTabs = useHasProductTabs();
  const { isLoading } = useProjectsAccess();
  const { isClassicNav } = useClassicNavPreference();
  return (
    hasProductTabs ||
    (isLoading && Boolean(appAmpV2) && !isClassicNav && getSavedIsProductNav())
  );
};
